import React from "react";

const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 ring-slate-200",
  onboarding: "bg-amber-100 text-amber-800 ring-amber-200",
  active: "bg-emerald-100 text-emerald-800 ring-emerald-200",
  inactive: "bg-gray-100 text-gray-700 ring-gray-200",
  suspended: "bg-rose-100 text-rose-800 ring-rose-200",
  deleted: "bg-stone-100 text-stone-600 ring-stone-200",
  enabled: "bg-emerald-100 text-emerald-800 ring-emerald-200",
  disabled: "bg-gray-100 text-gray-700 ring-gray-200",
  setup_required: "bg-amber-100 text-amber-800 ring-amber-200",
  invited: "bg-blue-100 text-blue-800 ring-blue-200",
  pending: "bg-slate-100 text-slate-700 ring-slate-200",
  in_progress: "bg-amber-100 text-amber-800 ring-amber-200",
  completed: "bg-emerald-100 text-emerald-800 ring-emerald-200",
  skipped: "bg-gray-100 text-gray-700 ring-gray-200",
  removed: "bg-stone-100 text-stone-600 ring-stone-200",
};

const BASE_SIZES = "px-2.5 py-1 text-xs font-semibold";
const COMPACT_SIZES = "px-2 py-0.5 text-[9px] font-medium leading-none";

const StatusBadge = ({ status, className = "" }) => {
  const key = String(status || "unknown").toLowerCase();
  const styles = STATUS_STYLES[key] || "bg-slate-100 text-slate-700 ring-slate-200";
  const sizes = key === "completed" ? COMPACT_SIZES : BASE_SIZES;

  return (
    <span className={`inline-flex items-center rounded-full ${sizes} ring-1 ring-inset ${styles} ${className}`.trim()}>
      {status || "unknown"}
    </span>
  );
};

export default StatusBadge;
